module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "header-top flex items-end justify-between"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('div', {
    staticClass: "logo"
  })]), _vm._m(0), _c('div', {
    staticClass: "flex items-end"
  }, [_c('div', {
    staticClass: "date caps mr3"
  }, [_vm._v(_vm._s(_vm.curDate))]), (_vm.isLogin) ? [_c('span', {
    staticClass: "user-name truncate",
    attrs: {
      "title": _vm.userName
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _c('span', {
    staticClass: "btn",
    on: {
      "click": _vm.publish
    }
  }, [_vm._v("Đăng bài")]), _c('ul', {
    staticClass: "person-panel"
  })] : _vm._e()], 2)], 1), _c('nav', [_c('ul', {
    staticClass: "nav-list my0 list-reset flex justify-between"
  }, _vm._l((_vm.navList), function(item, idx) {
    return _c('router-link', {
      key: idx,
      staticClass: "truncate",
      class: parseInt(_vm.$route.query.id) === item.cid ? 'active' : !_vm.$route.query.id && idx === 0 ? 'active' : '',
      attrs: {
        "to": idx === 0 ? {
          path: '/'
        } : {
          path: '/',
          query: {
            id: item.cid
          }
        },
        "tag": "li"
      }
    }, [_vm._v(_vm._s(item.label))])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "download",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.thtopnews.app",
      "alt": "",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('div', {
    staticClass: "download-googleplay"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e00a6da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 930
// module chunks = 1